export default {
    meta: {
        title: '鱼你在一起-拓店任务搜索',
        url: '/fishtogether/tasklist',
        urlName: '鱼你拓店任务'
    }
};
